import Svg from '../generated/DesignElementBb4';
import { Icon, type IconProps } from './Icon';

export const DesignElementBb4Icon = (props: IconProps) => (
    <Icon component={Svg} name="designElementBb4" inheritColors={false} {...props} />
);
